import React, { useState } from "react";
import Page from "../../../components/Page";
import { Box, Paper, TextField, Typography } from "@mui/material";
import Breadcrumb from "../../../components/breadcrumb/BreadCrumb";
import BasicButton from "../../../components/mui/Button";
import GlobalSelectField from "../../../components/mui/GlobalSelectField";
import { DataGrid } from "@mui/x-data-grid";
import { CONVERSION_ANALYTICS_TBL_HEAD } from "../../../components/datagrid/CRM/OgaCoversionTableHead";
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CustomGridToolbar from "../../../components/datagrid/GridToolBar";

const OgaConversionAnalytics = () => {
    const [gridSize, setGridSize] = useState(5);

    const dummyData = [
        {
            serialNumber: 1,
            ogaName: "Dummy OGA 1",
            leadsAssigned: 50,
            processedLeads: 30,
            admissionConfirmed: 20,
            ProcessedLeadsPercentage: 60,
            totalLeadsConversionPercentage: 40,
            AdmissionConfirmedFromPreviousMonthLeads: 10,
            lastMonthTotalLeadsConversionPercentage: 25,
            totalSalesAmount: 5000,
            feeCollected: 3000,
        },
        {
            serialNumber: 2,
            ogaName: "Dummy OGA 2",
            leadsAssigned: 45,
            processedLeads: 25,
            admissionConfirmed: 15,
            ProcessedLeadsPercentage: 55,
            totalLeadsConversionPercentage: 33.33,
            AdmissionConfirmedFromPreviousMonthLeads: 8,
            lastMonthTotalLeadsConversionPercentage: 20,
            totalSalesAmount: 4000,
            feeCollected: 2500,
        },
        {
            serialNumber: 3,
            ogaName: "Dummy OGA 3",
            leadsAssigned: 60,
            processedLeads: 35,
            admissionConfirmed: 25,
            ProcessedLeadsPercentage: 58.33,
            totalLeadsConversionPercentage: 41.67,
            AdmissionConfirmedFromPreviousMonthLeads: 12,
            lastMonthTotalLeadsConversionPercentage: 30,
            totalSalesAmount: 6000,
            feeCollected: 3500,
        },
        {
            serialNumber: 4,
            ogaName: "Dummy OGA 4",
            leadsAssigned: 55,
            processedLeads: 40,
            admissionConfirmed: 30,
            ProcessedLeadsPercentage: 72.73,
            totalLeadsConversionPercentage: 54.55,
            AdmissionConfirmedFromPreviousMonthLeads: 15,
            lastMonthTotalLeadsConversionPercentage: 35,
            totalSalesAmount: 5500,
            feeCollected: 4000,
        },
        {
            serialNumber: 5,
            ogaName: "Dummy OGA 5",
            leadsAssigned: 70,
            processedLeads: 50,
            admissionConfirmed: 40,
            ProcessedLeadsPercentage: 71.43,
            totalLeadsConversionPercentage: 57.14,
            AdmissionConfirmedFromPreviousMonthLeads: 18,
            lastMonthTotalLeadsConversionPercentage: 40,
            totalSalesAmount: 7000,
            feeCollected: 5000,
        },
    ];

    return (
        <Page title="My Tasks">
            <Box
                sx={{
                    width: "90%",
                    margin: "0 auto",
                }}
            >
                <Typography variant="h4" sx={{ mb: 1 }}>
                    OGA Conversion Analytics
                </Typography>
                <Breadcrumb sx={{ paddingLeft: 0.3 }} />
                <Box>
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "right",
                        }}
                    >
                        <BasicButton
                            variant="contained"
                            sx={{
                                display: "flex",
                                gap: 1,
                            }}
                        >
                            Unassigned Leads :-0
                        </BasicButton>
                    </Box>
                    <Paper
                        elevation={3}
                        sx={{ borderRadius: 1, width: "100%", mt: 4 }}
                    >
                        <Box
                            sx={{
                                backgroundColor: "grey.200",
                                borderRadius: "8px 8px 0 0",
                                display: "flex",
                                p: 2,
                                gap: 2,
                            }}
                        >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DesktopDatePicker
                                    label="From Date"
                                    inputFormat="YYYY/MM/DD"
                                    // onChange={handleDateDateChange}
                                    renderInput={(params) => (
                                        <TextField
                                            variant="filled"
                                            {...params}
                                        />
                                    )}
                                />
                                <DesktopDatePicker
                                    label="To Date"
                                    inputFormat="YYYY/MM/DD"
                                    // onChange={handleDateDateChange}
                                    renderInput={(params) => (
                                        <TextField
                                            variant="filled"
                                            {...params}
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                            <GlobalSelectField
                                options={{
                                    label: "Course",
                                }}
                            />
                            <GlobalSelectField
                                options={{
                                    label: "lead Type",
                                }}
                            />
                        </Box>

                        <Box sx={{ width: "100%", padding: 0 }}>
                            <DataGrid
                                rows={dummyData}
                                columns={CONVERSION_ANALYTICS_TBL_HEAD}
                                components={{ Toolbar: CustomGridToolbar }}
                                autoHeight
                                sx={{
                                    "& .MuiDataGrid-columnHeaderTitle": {
                                        textOverflow: "clip",
                                        whiteSpace: "break-spaces",
                                        lineHeight: 1,
                                        textAlign: "center",
                                    },
                                }}
                                getRowId={(row) => row.serialNumber}
                                pageSize={gridSize}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                onPageSizeChange={(newGridSize) =>
                                    setGridSize(newGridSize)
                                }
                            />
                        </Box>
                    </Paper>
                </Box>
            </Box>
        </Page>
    );
};

export default OgaConversionAnalytics;
